"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

var _react = _interopRequireWildcard(require("react"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _uuid = _interopRequireDefault(require("uuid"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var _DynamicFeedbackItems = _interopRequireDefault(require("../feedback/DynamicFeedbackItems"));

require("../activity.scss");

var _ActivityItemLabel = _interopRequireDefault(require("../ActivityItemLabel"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};
const defaultFeedback = {
  uuid: '',
  title: '',
  text: '',
  min: undefined,
  max: undefined,
  isOverallFeedback: false
};
var Type;

(function (Type) {
  Type[Type["zero"] = 0] = "zero";
  Type[Type["quiz"] = 1] = "quiz";
  Type[Type["category"] = 2] = "category";
  Type[Type["category_no_answer"] = 3] = "category_no_answer";
  Type[Type["cyoa"] = 4] = "cyoa";
  Type[Type["fill_in_the_blank"] = 5] = "fill_in_the_blank";
  Type[Type["goals"] = 6] = "goals";
  Type[Type["ranking"] = 7] = "ranking";
  Type[Type["screener"] = 8] = "screener";
})(Type || (Type = {}));

class ActivityReviewForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.form = /*#__PURE__*/_react.default.createRef();

    this.updateActivityFeedback = feedback => {
      const {
        setActivity
      } = this.props;
      setActivity({
        feedback
      });
    };

    this.updateFeedback = (fb, index) => {
      const {
        activity,
        setActivity
      } = this.props;
      const {
        feedback
      } = activity;

      if (feedback) {
        feedback[index] = fb;

        if (feedback[index].isOverallFeedback) {
          setActivity({
            overallFeedback: feedback[index]
          });
        }

        this.updateActivityFeedback(feedback);
      }
    };

    this.addFeedback = () => {
      const {
        activity
      } = this.props;
      const {
        feedback
      } = activity;
      let updatedFeedback = feedback ? _.cloneDeep(feedback) : [];

      const newFeedback = _.cloneDeep(defaultFeedback);

      newFeedback.uuid = (0, _uuid.default)();

      if (!activity.feedback) {
        updatedFeedback = [newFeedback];
      } else {
        updatedFeedback[updatedFeedback.length] = newFeedback;
      }

      this.updateActivityFeedback(updatedFeedback);
    };

    this.removeFeedback = index => {
      const {
        activity
      } = this.props;
      let i = 0;
      activity.feedback = activity.feedback ? activity.feedback.filter(f => {
        return index !== i++;
      }) : [];
      this.updateActivityFeedback(activity.feedback);
    };

    this.onRandomizeQuestionChange = e => {
      const {
        setActivity
      } = this.props;
      setActivity({
        randomizeQuestions: e.target.checked
      });
    };

    this.onHealthAssessmentChange = e => {
      const {
        setActivity
      } = this.props;
      setActivity({
        isHealthAssessment: e.target.checked
      });
    };

    this.onPublishDateChange = (date, dateString) => {
      const {
        setActivity
      } = this.props;
      setActivity({
        publishDate: dateString
      });
    };
  }

  componentDidMount() {
    const {
      setActiveForm
    } = this.props;
    setActiveForm(this.form.current);
  }

  render() {
    const {
      creative,
      editable,
      activity
    } = this.props;
    const {
      randomizeQuestions,
      publishDate,
      feedback,
      options,
      type
    } = activity;
    const displayRandomizeQuestions = [Type.goals, Type.ranking, Type.cyoa].indexOf(parseInt(type)) === -1;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form"
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "form",
      layout: "horizontal",
      colon: false
    }, displayRandomizeQuestions && /*#__PURE__*/_react.default.createElement(Item, {
      name: "randomizeQuestions",
      style: itemStyle,
      rules: [{
        required: false
      }],
      initialValue: randomizeQuestions
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      disabled: !creative && !editable,
      checked: randomizeQuestions,
      onChange: this.onRandomizeQuestionChange
    }, "Randomize Questions")), /*#__PURE__*/_react.default.createElement(Item, {
      name: "publishDate",
      label: /*#__PURE__*/_react.default.createElement(_ActivityItemLabel.default, {
        label: "Publish Date:",
        tooltip: "This is when this article will be available to the participants.  The exact moment it will be published is the first second of the day in Eastern Standard Time"
      }),
      style: itemStyle,
      rules: [{
        required: false
      }],
      initialValue: publishDate ? (0, _moment.default)(publishDate) : undefined
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      disabled: !creative && !editable,
      onChange: this.onPublishDateChange
    })), /*#__PURE__*/_react.default.createElement("h4", null, "Activity Feedback:"), /*#__PURE__*/_react.default.createElement(_DynamicFeedbackItems.default, {
      type: 0,
      disabled: !creative && !editable,
      options: options || [],
      feedback: feedback || [],
      updateFeedback: this.updateFeedback,
      addFeedback: this.addFeedback,
      removeFeedback: this.removeFeedback
    })));
  }

}

var _default = ActivityReviewForm;
exports.default = _default;